import { render, staticRenderFns } from "./TabletNicheDetail.vue?vue&type=template&id=465acf10"
import script from "./TabletNicheDetail.vue?vue&type=script&lang=js"
export * from "./TabletNicheDetail.vue?vue&type=script&lang=js"
import style0 from "./TabletNicheDetail.vue?vue&type=style&index=0&id=465acf10&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports